import { Component, Vue, Watch } from 'vue-property-decorator';
import MobileDetect from 'mobile-detect';
// @ts-ignore
import smoothscroll from 'smoothscroll-polyfill/dist/smoothscroll.js';
import { getCoords } from '../utils/miscellanea';

smoothscroll.polyfill();

const md = new MobileDetect(navigator.userAgent);
const itemsPerPage = 6;

interface Item {
  id: string;
  alias: string;
  title: string;
  created: string;
  tags: Array<string>;
  introtext: string;
  link: string;
}

interface Tag {
  id: string;
  title: string;
}

@Component
export default class VMBlog extends Vue {
  tagId = '0';
  page = 1;
  isMobile = md.mobile();

  allItems: Array<Item> = [];
  tags: Array<Tag> = [];

  get items(): Array<Item> {
    return this.tagId == '0'
      ? this.allItems
      : this.allItems.filter(i => i.tags.indexOf(this.tagId) !== -1);
  }

  get nav(): Array<number> {
    const total = Math.ceil(this.items.length / itemsPerPage);
    const arr = [];

    for (let i = 1; i <= total; i++) {
      arr.push(i);
    }

    return arr;
  }

  get itemsOnPage() {
    if (this.isMobile) {
      return this.items.slice(0, (this.page * itemsPerPage));
    }

    return this.items.slice((this.page - 1) * itemsPerPage, (this.page * itemsPerPage));
  }

  @Watch('catId')
  _onCatIdChanged(val: any): void {
    this.page = 1;
  }

  @Watch('page')
  _onPageChanged(val: any): void {
    this.$nextTick(() => {
      if (this.isMobile) {
        location.hash = `page-${this.page}`
      }

      setTimeout(() => {
        const key = this.isMobile ? (this.page - 1) * itemsPerPage : 0;
        const item = (<Array<HTMLElement>>this.$refs._itemsOnPage)[key];
        const coords = getCoords(item);

        window.scroll({
          top: coords.top - (this.isMobile ? 50 : 100),
          left: 0,
          behavior: 'smooth'
        });
      }, 10);
    });
  }

  created(): void {
    const postsJSON = document.getElementById('posts_list')?.textContent;
    if (postsJSON) {
      this.allItems = JSON.parse(postsJSON);
      Object.freeze(this.allItems);
    }

    const tagsJSON = document.getElementById('tags_list')?.textContent;
    if (tagsJSON) {
      this.tags = JSON.parse(tagsJSON);
      this.tags.unshift({ id: '0', title: 'Все' });
      Object.freeze(this.tags);
    }

    const tagMatch = location.hash.match(/tag\-([0-9]+)/);
    if (tagMatch != null) {
      this.tagId = `${tagMatch[1]}`;
    }

    const pageMatch = location.hash.match(/page\-([0-9]+)/);
    if (this.isMobile && pageMatch != null) {
      this.page = parseInt(pageMatch[1]);
    }
  }

  nextPage() {
    if (this.page + 1 <= this.nav.length) {
      this.page = this.page + 1;
    }
  }
}
